import { VariantDate } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/elements/VariantDate.tsx';
import { VariantPoint } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/elements/VariantPoint.tsx';
import { VariantStar } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/elements/VariantStar.tsx';
import { VariantSizes } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/shared/variantUtils';
import { VariantWrapText } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/shared/VariantWrapText.tsx';
import styled, { CSSProperties } from 'styled-components';

interface VIEventProps {
    color: string;
    highlighted: boolean;
    title: string;
    size: VariantSizes;
    eventDate: string;
    style?: CSSProperties;
    className?: string;
}

export const VIEvent = (props: VIEventProps) => {
    return (
        <S_VIEvent className={props.className} style={props.style}>
            <S_WrapIcon>
                {props.size === 1 && <VariantPoint color={props.color} />}
                {(props.size === 2 || props.size === 3) && (
                    <>
                        <VariantDate date={new Date(props.eventDate)} />
                        {props.highlighted && <S_VariantStar />}
                    </>
                )}
            </S_WrapIcon>
            {props.size === 3 && <S_VariantWrapText top={33} variantText={{ text: props.title }} />}
        </S_VIEvent>
    );
};

const S_VIEvent = styled.div`
    display: flex;
    flex-direction: column;
    width: fit-content;
    position: relative;
    width: 35px;
    height: 35px;
    justify-content: center;
    align-items: center;
    user-select: none;
`;

const S_WrapIcon = styled.div`
    position: relative;
    z-index: 1;
`;

const S_VariantStar = styled(VariantStar)`
    position: absolute;
    top: -7px;
    right: -7px;
`;

const S_VariantWrapText = styled(VariantWrapText)`
    z-index: 2;
`;
